import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import * as breakpoints from '../../../data/breakpoints';
import PaymentHistoryTableRow from './PaymentHistoryTableRow';
import NoResultsMessage from '../../Global/Messages/NoResultsMessage';

const PaymentHistoryTable = ({ paidHistoryArr, loading }) => {
  // Logic for what to render when there are no payments made is taken from LicenceeTable
  const noResultsOrLoadingTableBody = (
    <tr><td colSpan="8" className="p-a-0">
      <NoResultsMessage
        title="You have no payment history"
        text="This is where you can find the history of every instalment you have made to TCM."
        loading={loading}
      />
    </td></tr>
  );

  let tableBody;
  
  if (loading) {
    tableBody = noResultsOrLoadingTableBody;
  } else if (paidHistoryArr.length > 0) {
    tableBody = (
      paidHistoryArr.filter(paidHistoryEntry => paidHistoryEntry.amount !== undefined).map(paidHistoryEntry => (
        <PaymentHistoryTableRow
          key={paidHistoryEntry.id}
          paidHistoryEntry={paidHistoryEntry}
        />
      ))
    );
  } else {
    tableBody = noResultsOrLoadingTableBody;
  }

  return (
    <table className="licence-table table w-100 m-b-3">
      <thead className="thead">
        <tr>
          <th>Date</th>
          <th>Plan</th>
          <MediaQuery minWidth={breakpoints.SMALL}>
            <th>Type</th>
          </MediaQuery>
          <th>Price</th>
          <th>Amount Due</th>
          <th>Amount Paid</th>
          <th>Invoice</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody className="tbody">
        {tableBody}
      </tbody>
    </table>
  );
};

PaymentHistoryTable.propTypes = {
  paidHistoryArr: PropTypes.array,
  loading: PropTypes.bool,
};

export default PaymentHistoryTable;


// WEBPACK FOOTER //
// ./library/app/components/Account/PaymentHistory/PaymentHistoryTable.js